module.exports = __webpack_public_path__ + "static/media/ManageCard.09edc1b7.svg";